export const splitStringIntoChunks = (str: string, chunk: number) => {
  const chunks = [];
  for (let i = 0; i < str.length; i += chunk) {
    chunks.push(str.substring(i, i + chunk));
  }
  return chunks;
};
